export default __webpack_public_path__ + "media/components/MapSelectorModal/pro-badge-295de9b9d48073faffcddb546157d929.svg";